import { useState,useRef, useEffect } from 'react';
import { 
    IonButton,
    IonIcon,
    IonText,
    IonCard,
    IonRow,
    IonCol,
    IonGrid,
    IonInput,
    IonTextarea,
    IonSelectOption,
    IonSelect
} from '@ionic/react';
import {
    mailOutline
} from "ionicons/icons";
import Fade from 'react-reveal/Fade';

// import axios from 'axios';
//import {AxiosHelper} from '../../utils/AxiosHelper';
import ReCAPTCHA from "react-google-recaptcha";
import superFetch from "../../utils/superFetch"

import './FormSection.css';

import industryOptions from '../../data/industryList.json';

const FormSection = (present) => {

    const [activeFormField, setActiveFormField] = useState(null);

    const [name, setName] = useState('');
    const [cName, setCName] = useState('');
    const [email, setEmail] = useState('');
    const [industry, setIndustry] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [errorFields, setErrorFields] = useState({})
    const [CaptchaValue,setCaptchaValue] = useState('');

    const captcha = useRef(null);

    useEffect(() => {
        if (CaptchaValue) {
            captcha.current.reset();
            setCaptchaValue('');
        }
    }, [CaptchaValue])

    const clearForm = () => {
        setName('')
        setCName('')
        setEmail('')
        setPhone('')
        setMessage('')
    }

    // Validate Handphone Number Function
    const validatePhoneNumber = (phone) => {
        if(phone.length !== 8){
            return false;
        }else if (!['8','9'].includes(phone.substring(0,1))){
            // First Number of Handphone Number
            return false;
        }else if(!phone.match(/^[0-9]+$/)){
            return false
        }
        return true;
    }
    // Validate Email Function
    const validateEmail = (email) => {
        if(email.length === 0){
            return false;
        } else if (!email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/)){
            return false;
        }
        return true;
    }

    // Not Empty Function
    const notEmpty = (value) => {
        if(value.length === 0){
            return false;
        }
        return true;
    }

    // Function to check input
    const checkInput = () => {
        var inputFields = {
            'name': name,
            'phone': phone,
            'email': email,
            'cName': cName,
            'message': message
        }
        
        var error = {}
        var inputFieldsKeys = Object.entries(inputFields);
        inputFieldsKeys.forEach(([key, value]) => {
            if(!notEmpty(value)){
                if (!Object.keys(error).includes(key)){
                    error[key] = "This field is required";
                }
            }
            if (key==='phone' && !validatePhoneNumber(value)){
                if (!Object.keys(error).includes('phone')){
                    error['phone'] = "Enter a valid phone number";
                }
            }
            if (key==='email' && !validateEmail(value)){
                if (!Object.keys(error).includes('email')){
                    error['email'] = "Enter a valid email";
                }
            }
        }
        )
       
        setErrorFields(error);
        if(Object.keys(error).length === 0){
            return true;
        }
        return false;
    }           

    // function to format and send email
    const sendEmail =  async () => {
        // var captchaToken = await captcha.current.execute();
        // setErrorFields({});
        // Check if all required fields are filled
        
        if(checkInput()){
                const formData = {
                    "name": name,
                    "companyName": cName,
                    "email": email,
                    "contactNumber": phone,
                    "message": message+'\nIndustry: '+industry,
                }
                
                try{
                    // Captcha token is passes as the bearer token -even though its not JWT, for backend to verify if user cleared the captcha
                    // var response = await axios.post(`${process.env.REACT_APP_SEND_API}/api/send/email`, formData,{ headers:{'Authorization':`Bearer ${captchaToken}`} })
                    let response = await superFetch('/api/send/support/enquiry', "post", formData)
                    
                    if (response.status){
                        present({
                            header: 'Success',
                            message: "Email Sent Successfully",
                            buttons: [
                                'Okay',
                            ],
                            mode: 'ios',
                        })
                        clearForm();
                    } else {
                        present({
                            header: 'Error',
                            message: response.response.data.error.message,
                            buttons: [
                                'Okay',
                            ],
                            mode: 'ios',
                        })
                    }
                } catch (err) {
                }
        } else {
            present({
                header: 'Error',
                message: "Please Fill in all required fields",
                buttons: [
                    'Okay',
                ],
                mode: 'ios',
            })
        }
    }

    

    return(
        <div style={{
            height:'fit-content', 
        }}>
            <IonGrid style={{
            height:'fit-content',
            paddingBlock:'20px',
            paddingBottom: '40px',
            display:'flex',
            flexDirection:'column',
            alignItems:'center',
            justifyContent:'flex-start',
            background:'#E93864'
        }}>
        <IonRow style={{maxWidth:'1200px', width:'100%'}}>
            <IonCol sizeMd={5} size={12} style={{
                display:'flex',
                flexDirection:'column',
                justifyContent:'flex-start',
                padding: '20px',
                color:'white'
            }}>
                <Fade up>
                    <>
                    <IonText 
                    className="font-baloo font-bold font-xl"
                    style={{
                        display:'block',
                        lineHeight:'2rem',
                        // fontSize:'1.5rem',
                        // fontWeight:'600',
                    }}>Grow Your Business With RydeSEND</IonText>
                    <IonText 
                    className="font-opensans font-s"
                    style={{
                        display:'block',
                        marginBlock:'20px',
                        fontSize:'0.9rem',
                    }}>Tell us more about your business.<br/>Our team will reach out shortly.</IonText>
                    <div style={{
                        display:'flex',
                        flexDirection:'row',
                        // justifyContent:'center',
                        alignItems:'center',
                    }}>
                        <div style={{
                            display:'flex',
                            width:'fit-content',
                            fontSize:'0.9rem',
                            padding: '5px',
                            color: '#E93864',
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            marginInlineEnd:'5px',
                        }}><IonIcon icon={mailOutline}/></div>
                        <IonText 
                        className="font-opensans font-s"
                        style={{
                            display:'block',
                        }}> support@rydesharing.com</IonText>
                    </div>
                    </>
                </Fade>
            </IonCol>
            <IonCol sizeMd={7} size={12}>
                <Fade up>
                <IonCard style={{
                    padding: '10%',
                    borderRadius: '20px',
                    boxShadow: '5px 5px 5px 0px rgba(0,0,0,0.1)',
                }}>
                    <IonRow style={{
                        justifyContent:'flex-end'
                    }}>
                        <IonCol sizeMd={6} size={12}>
                            <IonInput
                            className="border-radius-10"
                            style={{
                                paddingLeft: '5px', 
                                border: activeFormField==='name'?'1px solid #F3A2BF':'1px solid #E3E3E3',
                            }}
                            value={name} 
                            id="name"
                            placeholder="Full Name" 
                            pattern="text"
                            // autofocus={true} 
                            autocomplete="on"
                            onIonFocus={() => {setActiveFormField('name')}}
                            onBlur={() => {setActiveFormField(null)}}
                            onIonChange={(e) => {setName(e.detail.value)}}></IonInput>
                            {
                                Object.keys(errorFields).includes('name')?
                                <span style={{
                                    display: 'block',
                                    color: '#e93864'
                                }}>{errorFields.name}</span>:
                                null
                            }
                        </IonCol>
                        
                        <IonCol sizeMd={6} size={12}>
                            <IonInput 
                            className="border-radius-10"
                            style={{
                                height: '72px',
                                paddingLeft: '5px', border: activeFormField==='cName'?'1px solid #F3A2BF':'1px solid #E3E3E3',
                            }}
                            value={cName} 
                            id="cName"
                            placeholder="Company Name" 
                            pattern="text"
                            // autofocus={true}
                            autocomplete="on"
                            onIonFocus={() => {setActiveFormField('cName')}}
                            onBlur={() => {setActiveFormField(null)}}
                            onIonChange={(e) => {setCName(e.detail.value)}}></IonInput>
                            {
                                Object.keys(errorFields).includes('cName')?
                                <span style={{
                                    display: 'block',
                                    color: '#e93864'
                                }}>{errorFields.cName}</span>:
                                null
                            }
                        </IonCol>

                        <IonCol sizeMd={6} size={12}>
                            <IonInput 
                            className="border-radius-10"
                            style={{
                                paddingLeft: '5px', border: activeFormField==='phone'?'1px solid #F3A2BF':'1px solid #E3E3E3',
                            }}
                            value={phone} 
                            id="phone"
                            placeholder="Contact Number" 
                            pattern="tel"
                            autocomplete="on"
                            onIonFocus={() => {setActiveFormField('phone')}}
                            onBlur={() => {setActiveFormField(null)}}
                            maxlength={8}
                            onIonChange={(e) => {setPhone(e.detail.value)}}></IonInput>
                            {
                                Object.keys(errorFields).includes('phone')?
                                <span style={{
                                    display: 'block',
                                    color: '#e93864'
                                }}>{errorFields.phone}</span>:
                                null
                            }
                        </IonCol>

                        <IonCol sizeMd={6} size={12}>
                        <IonSelect  
                            mode='ios'
                            className="border-radius-10"
                            style={{
                                paddingLeft: '10px',
                                maxHeight: '72px',
                                border: activeFormField==='industry'?'1px solid #F3A2BF':'1px solid #E3E3E3',
                            }}
                            interface="popover" 
                            id="industry"
                            placeholder="Industry"
                            value={industry} 
                            onIonFocus={() => {setActiveFormField('industry')}}
                            onBlur={() => {setActiveFormField(null)}}
                            onIonChange={(e) => {setIndustry(e.detail.value)}}
                            >
                            {
                                industryOptions.map((option,index) => {
                                return(
                                <IonSelectOption 
                                key={index} 
                                value={option.label}
                                >
                                {option.label}
                                </IonSelectOption>
                                )
                            })
                            }
                        </IonSelect>
                            {
                                Object.keys(errorFields).includes('phone')?
                                <span style={{
                                    display: 'block',
                                    color: '#e93864'
                                }}>{errorFields.phone}</span>:
                                null
                            }
                        </IonCol>
                        
                        <IonCol size={12}>
                            <IonInput 
                            className="border-radius-10"
                            style={{
                                paddingLeft: '5px', border: activeFormField==='email'?'1px solid #F3A2BF':'1px solid #E3E3E3',
                            }}
                            value={email} 
                            id="email"
                            placeholder="Email" 
                            pattern="email"
                            // autofocus={true}
                            autocomplete="on"
                            onIonFocus={() => {setActiveFormField('email')}}
                            onBlur={() => {setActiveFormField(null)}}
                            onIonChange={(e) => {setEmail(e.detail.value)}}></IonInput>
                            {
                                Object.keys(errorFields).includes('email')?
                                <span style={{
                                    display: 'block',
                                    color: '#e93864'
                                }}>{errorFields.email}</span>:
                                null
                            }
                        </IonCol>
                        <IonCol sizeMd={12} style={{}}>
                            <IonTextarea 
                            className="border-radius-10"
                            style={{
                                paddingTop: '5px',  border: activeFormField==='message'?'1px solid #F3A2BF':'1px solid #E3E3E3',
                            }}
                            value={message} 
                            id="message"
                            placeholder="Message" 
                            pattern="text"
                            // autofocus={true}
                            autocomplete="on"
                            auto-grow={true}
                            onIonFocus={() => {setActiveFormField('message')}}
                            onBlur={() => {setActiveFormField(null)}}
                            onIonChange={(e)=>setMessage(e.detail.value)}
                            ></IonTextarea>
                            {
                                Object.keys(errorFields).includes('message')?
                                <span style={{
                                    display: 'block',
                                    color: '#e93864'
                                }}>{errorFields.message}</span>:
                                null
                            }
                        </IonCol>

                        <IonCol sizeMd={6} size={12}>
                            <IonButton 
                            className="prelogin-button"
                            onClick={() => {sendEmail()}}
                            style={{
                                width: '100%'
                            }}>Submit</IonButton>
                        </IonCol>
                        
                    </IonRow>
                </IonCard>
                </Fade>
            </IonCol>
        </IonRow>
        </IonGrid>
        {/* <ReCAPTCHA
        ref={captcha}
        sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
        onChange={(value) => {setCaptchaValue(value)}}
        size="invisible"
        /> */}
        </div>
    )
}

export default FormSection;